import { Link } from 'foundations-components/transitional/components/Link';
import { scrollToSection } from '../utils/scrollUtils';
import { trackClickedLink } from '../utils/tracking/trackingEventUtils';
import { jsx as _jsx } from "react/jsx-runtime";
export const ScrollLink = ({
  targetId,
  children
}) => {
  const handleClick = event => {
    event.preventDefault();
    trackClickedLink({
      type: 'internal',
      url: `#${targetId}`,
      name: `${targetId} scroll link`
    });
    scrollToSection(targetId);
  };
  return /*#__PURE__*/_jsx(Link, {
    href: `#${targetId}`,
    onClick: handleClick,
    children: children
  });
};